import { useMutation } from '@tanstack/react-query';
import { CompanyModel } from '../domain';
import { companiesRepo } from '@/constants/providers';

export const useCreateCompany = () =>
  useMutation<CompanyModel, unknown, FormData>((data) =>
    companiesRepo.createCompany(data),
  );
